import { memo } from 'react';

type TimerDisplayProps = {
  minutes: string;
  seconds: string;
  isTimerEnd: boolean;
  endMessage?: string;
  prefix?: string;
  className?: string;
};

export const TimerDisplay = memo(
  ({
    minutes,
    seconds,
    isTimerEnd,
    endMessage,
    prefix,
    className,
  }: TimerDisplayProps) => {
    if (isTimerEnd && endMessage) {
      return <span className={className}>{endMessage}</span>;
    }

    return (
      <span className={className}>
        {prefix && `${prefix} `}
        {minutes}:{seconds}
      </span>
    );
  },
);

TimerDisplay.displayName = 'TimerDisplay';
